// src/belediye/services/kurulumRehberiZaman.js
//
// FAZ-102 — KURULUM REHBERİ NE ZAMAN VE KAÇ KEZ ÇIKAR?
//
// Kullanıcı (2026-08-02): "her seferinde değil de belki bir kez, belki birden
// fazla kez."  İki uç da kötüdür:
//   • HER GİRİŞTE çıkarmak insanları küstürür; ilk yaptıkları şey "bir daha
//     sorma"ya basmak olur ve kalıcı olarak kaybedilirler.
//   • BİR KEZ çıkarıp susmak çoğunu kaçırır; o gün işi vardır, kapatır, unutur.
//
// Seçilen kural: ÜÇ KEZ SOR, ARALARINI AÇ, SONRA SUS — AMA KAPIYI AÇIK BIRAK.
//   1. gösterim  →  "Şimdi değil" →   3 gün sessizlik
//   2. gösterim  →  "Şimdi değil" →  10 gün sessizlik
//   3. gösterim  →  "Şimdi değil" →  bir daha OTOMATİK sormaz
//   "Bir daha sorma"                →  anında ve kalıcı susar
// Ayarlardaki kurulum bloğu her zaman yerinde durur — rehber sussa da yol açık.
//
// ADIM TAMAMLANINCA SAYAÇ SIFIRLANIR. Kişi iPhone'da uygulamayı ana ekrana
// ekledi ama izni vermediyse bu YENİ bir durumdur: geriye tek dokunuş kalmıştır
// ve sorduğumuz şey değişmiştir. Aynı hakları yeni aşama için yeniden tanımak,
// "üç kez sordum artık susarım" kuralından daha doğrudur.
//
// KAYIT CİHAZ BAZLIDIR (localStorage): kurulum cihaza özgüdür. Kişinin
// bilgisayarda "sorma" demesi, telefonunda sormamızı engellememelidir.
// Anahtar kullanıcı kimliğini taşır — ortak bilgisayarda iki personelin kaydı
// birbirine karışmasın.

const ONEK = "kim.kurulumRehberi.v1";

// Erteleme merdiveni (gün). Son basamaktan sonra otomatik gösterim biter.
export const ERTELEME_GUN = [3, 10];
export const AZAMI_GOSTERIM = 3;

const GUN_MS = 24 * 60 * 60 * 1000;

const anahtar = (userId) => `${ONEK}.${userId || "anonim"}`;

const bosKayit = () => ({ gosterim: 0, sonrakiTarih: 0, kapali: false, asama: "" });

export function kayitOku(userId) {
  try {
    const ham = window.localStorage.getItem(anahtar(userId));
    if (!ham) return bosKayit();
    const v = JSON.parse(ham);
    return {
      gosterim: Number(v.gosterim) || 0,
      sonrakiTarih: Number(v.sonrakiTarih) || 0,
      kapali: Boolean(v.kapali),
      asama: String(v.asama || ""),
    };
  } catch (_) {
    // Bozuk/erişilemez depo, rehberi bozmaz — hiç sorulmamış gibi davranılır.
    return bosKayit();
  }
}

function kayitYaz(userId, kayit) {
  try {
    window.localStorage.setItem(anahtar(userId), JSON.stringify(kayit));
  } catch (_) {}
}

/**
 * Kişinin şu anda hangi aşamada olduğunu tek kelimeyle söyler. Sayaç
 * sıfırlamanın ölçüsü budur — "durum" değil "AŞAMA" değişince yeniden sorulur.
 *
 *   "kurulmamis"  → uygulama ana ekrana eklenmeden HİÇBİR ŞEY yapılamaz (yalnız iOS)
 *   "izin-yok"    → tek iş kaldı: bildirime izin vermek
 *   "tamam"       → abone; rehberin işi bitti
 *
 * ══════════════════════════════════════════════════════════════════════════
 * FAZ-103 — KURULUM YALNIZ iPHONE'DA ZORUNLUDUR.
 *
 * İlk sürüm, telefon demek "önce uygulamayı kur" demek sanıyordu ve Android'i
 * de iPhone kuralına tabi tutuyordu. Yanlış:
 *
 *   • iOS'ta Push/Notification API'leri ana ekrana eklenmeden ÇALIŞMAZ.
 *     Kurulum, izin isteyebilmenin ÖN KOŞULUDUR.
 *   • Android'de (ve masaüstünde) bildirim, sıradan bir tarayıcı sekmesinde
 *     de çalışır. Kurulum İSTEĞE BAĞLIDIR; simge ve rozet için güzeldir ama
 *     bildirimin şartı değildir.
 *
 * Android kullanıcısını kuruluma zorlamak, konum izni isterken önce
 * "uygulamayı ana ekrana ekleyin" demeye benzerdi: gereksiz bir engel. Orada
 * doğru davranış, izin istemini DOĞRUDAN açmaktır — konum izninde olduğu gibi.
 * ══════════════════════════════════════════════════════════════════════════
 */
export function asamaBelirle({ standalone, izin, abone, platform }) {
  if (abone) return "tamam";
  // iOS'un zorunlu ön koşulu. Sıra burada bilinçli: izin durumuna bakmadan
  // önce sorulur, çünkü kurulmamış iPhone'da izin ZATEN sorulamaz.
  if (platform === "ios" && !standalone) return "kurulmamis";
  return "izin-yok";
}

/**
 * Rehber şimdi gösterilmeli mi?
 * `simdi` DIŞARIDAN verilir — test edilebilir olsun ve saat okuma tek yerde
 * kalsın diye.
 */
export function gosterilsinMi({ userId, asama, simdi = Date.now() }) {
  if (asama === "tamam") return false;
  const k = kayitOku(userId);
  if (k.kapali) return false;

  // AŞAMA DEĞİŞTİYSE: yeni bir iş var, haklar yenilenir.
  if (k.asama && k.asama !== asama) return true;

  if (k.gosterim >= AZAMI_GOSTERIM) return false;
  if (k.sonrakiTarih && simdi < k.sonrakiTarih) return false;
  return true;
}

/** Rehber ekrana geldi. */
export function gosterildiIsaretle({ userId, asama }) {
  const k = kayitOku(userId);
  const yeniAsama = k.asama && k.asama !== asama;
  kayitYaz(userId, {
    ...k,
    // Aşama değiştiyse sayaç sıfırdan başlar (yukarıdaki gerekçe).
    gosterim: yeniAsama ? 1 : k.gosterim + 1,
    asama,
  });
}

/** "Şimdi değil" — merdivenin bir sonraki basamağı kadar sus. */
export function ertele({ userId, simdi = Date.now() }) {
  const k = kayitOku(userId);
  // gosterim 1 → ERTELEME_GUN[0], 2 → ERTELEME_GUN[1], 3+ → otomatik gösterim
  // biter (sonrakiTarih'e gerek yok, AZAMI_GOSTERIM kapısı zaten kapatır).
  const gun = ERTELEME_GUN[Math.max(0, k.gosterim - 1)] || 0;
  kayitYaz(userId, {
    ...k,
    sonrakiTarih: gun ? simdi + gun * GUN_MS : 0,
  });
}

/** "Bir daha sorma" — kalıcı. */
export function birDahaSorma({ userId }) {
  kayitYaz(userId, { ...kayitOku(userId), kapali: true });
}

/** Kurulum tamamlandı; kayıt anlamını yitirdi, temizlenir. */
export function temizle({ userId }) {
  try {
    window.localStorage.removeItem(anahtar(userId));
  } catch (_) {}
}
